import { useEffect, useRef } from 'react'

type UseInfiniteScrollProps = {
  callback: () => void
  threshold?: number
  hasMore: boolean
}

export const useInfiniteScroll = ({
  callback,
  threshold = 10,
  hasMore,
}: UseInfiniteScrollProps) => {
  const scrollRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (hasMore) {
      const handleScroll = () => {
        const current = scrollRef.current
        if (!current) return

        const scrollHeight = current.scrollHeight
        const scrollTop = current.scrollTop
        const clientHeight = current.clientHeight

        if (scrollTop + clientHeight + threshold >= scrollHeight) {
          callback()
        }
      }

      scrollRef.current!.addEventListener('scroll', handleScroll)
      return () => {
        if (scrollRef.current) scrollRef.current.removeEventListener('scroll', handleScroll)
      }
    }
  }, [hasMore, callback, threshold])

  return scrollRef
}
